module.exports = __webpack_public_path__ + "static/media/event-branding.8554c9f2.png";